import { Routes } from "@angular/router";
import { AuthenticationGuard, AuthorizationGuard } from "@softline/auth";
import {importProvidersFrom, inject} from "@angular/core";
import {
  ConnectionHttpService,
  RemoteStoreObjectService,
  ResourceService,
  SOFTLINE_SERVICE_HTTP,
  SOFTLINE_STORE_OBJECT_SERVICE,
  SOFTLINE_STORE_REMOTE_OBJECT_SERVICE,
  SOFTLINE_STORE_TEMPLATE_SERVICE,
  SoftlineObjectService,
  SoftlineTemplateService,
  Store,
  StoreModule
} from "@softline/core";
import {
  SOFTLINE_FEATURE_PRODUKTKALKULATION,
  SOFTLINE_PERMISSION_PRODUKTKALKULATION
} from "./produktkalkulation.shared";
import { ProduktkalkulationStore } from "./store";
import { SOFTLINE_API_MASTER_DATA } from "@softline/application";
import {
  SOFTLINE_API_PRODUKTKALKULATION_STUECKLISTE,
  SOFTLINE_API_PRODUKTKALKULATION_TEMPLATE
} from "./produktkalkulation.api";
import { ProduktkalkulationService } from "./services/produktkalkulation.service";

export const produktkalkulationRoutes: Routes = [
  {
    path: 'produktkalkulation',
    children: [
      {path: '', loadComponent: () => import('./pages/produktkalkulation.page').then(o => o.ProduktkalkulationPage)},
      {path: '**', redirectTo: ''}
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: {permission: SOFTLINE_PERMISSION_PRODUKTKALKULATION},
    providers: [
      ProduktkalkulationService,
      importProvidersFrom(
        StoreModule.forFeature({
          name: SOFTLINE_FEATURE_PRODUKTKALKULATION,
          feature: ProduktkalkulationStore.feature,
          providers: [
            { provide: ProduktkalkulationService, useClass: ProduktkalkulationService },
            {
              provide: SOFTLINE_STORE_REMOTE_OBJECT_SERVICE,
              useFactory: (store: Store, service: ResourceService<any>) =>
                new SoftlineObjectService(service, SOFTLINE_API_PRODUKTKALKULATION_STUECKLISTE),
              deps: [Store, SOFTLINE_SERVICE_HTTP],
            },
            {
              provide: SOFTLINE_STORE_TEMPLATE_SERVICE,
              useFactory: () => new SoftlineTemplateService(
                inject(ConnectionHttpService),
                SOFTLINE_API_PRODUKTKALKULATION_TEMPLATE
              )
            }
          ],
        }),
      ),
    ]
  },
];
